import { FC } from 'react'

type Props = {
  label?: string
  symbol: string
  additionalClasses?: string
  onClick?: () => void
}

const Emoji: FC<Props> = ({ label = 'emoji', symbol, onClick, additionalClasses, ...props }) => (
  <span className={`emoji ${additionalClasses}`} role="img" aria-label={label} aria-hidden={label ? 'false' : 'true'} onClick={onClick} {...props}>
    {symbol}
  </span>
)

export default Emoji
